(function(){
  var rollingTimer, overlay;

  Pegasus.CommandManager = Em.ArrayController.extend({
    addObject: function(object){
      this.set('content', this.get('content').slice( 0, this.get('position') ));
      return this._super(object);
    },

    version: 0,

    position: 0,

    rollTo: function(idx) {
      Pegasus.lookupController('frameCommManager').send('requestRoll',  idx);
    },

    rollback: function(){
      if ( this.get('canRollback') ){
        Pegasus.lookupController('frameCommManager').send('requestRoll',  this.get('position') - 1);
      }
    },

    rollforward: function(){
      if ( this.get('canRollforward') ){
        Pegasus.lookupController('frameCommManager').send('requestRoll',  this.get('position') + 1);
      }
    },

    isMostRecent: function(){
      return this.get('position') === (this.get('content.length') - 1);
    }.property('position', 'content.length'),
    canRollforward: function(){
      return this.get('content.length') &&
        this.get('position') < this.get('content.length');
    }.property('position', 'content.length'),
    canRollback: function(){
      return !!( this.get('position') );
    }.property('position', 'content.length'),
    blockInteraction: function(callback){
      var translation = Em.I18n.t('g.loading');
      var mask = $('.loader-mask').length ? $('.loader-mask') : $('<div class="loader-mask"><div class="loading-wrapper"><div class="loading show">'+translation+'...</div></div></div>');
      mask.remove().appendTo('body');

      Em.run.cancel( window.rollingTimer );

      if ( callback ) {
        // Firefox needs an insane amount of time to paint the mask
        Em.run.later(null, callback/*passed callback should bind context*/, 100);
        return;
      }

      // We add/remove overflow setting for the `gg` email-style-wrapper
      window.rollingTimer = Em.run.later( this, function(){
        $('.loader-mask').remove();
        Em.run.later( $(window), 'trigger', 'frameChanged', 1000 );
      }, 500);
    }
  });

  Pegasus.CommandManager.reopenClass({
    reset: function(index){
      var instance = Em.get(this, 'instance');
      instance.clear();
      instance.set('position', 0);
    },

    create: function(args){
      var instance =  Em.get( this, 'get', 'instance');
      if (instance){
        return instance;
      }

      instance = this._super(args);
      Em.set(this, 'instance', instance);
      return instance;
    }
  });
})();
